var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.conf&&_vm.conf.Parameter)?_c('iframe',{staticStyle:{"border":"1px solid #ccc","width":"100%"},attrs:{"height":_vm.conf.Parameter.PageHeight,"src":_vm.conf.Parameter.PageUrl}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }